import {
  Button,
  CircularProgress,
  FormControl,
  TextField,
  Tooltip,
  FormHelperText,
} from "@mui/material";
import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import moment from "moment";
import { add_edit_program_workout_member_api } from "src/DAL/programmeWorkout/programmeWorkout";
import WorkoutExercisesUI from "../Workout/WorkoutExercisesUI";
import WorkoutExercisesUIClient from "./WorkoutExercisesUIClient";
import { Icon } from "@iconify/react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import WorkoutExercisesUILogedClient from "./WorkoutExercisesUILogedClient";
import {
  exercise_obj,
  formatExercises,
  generateExerciseArray,
  getValidMealArray,
  is_LG_screen,
  paceFromVdot,
  urlPatternValidation,
} from "src/utils/constant";
import { convertToTitleCase } from "src/utils/convertHtml";
import FoodMattersAndMindsetUI from "../FoodMattersLibrary/FoodMattersAndMindsetUI";
import AnswerdFoodMattersAndMindsetUI from "./AnswerdFoodMattersAndMindsetUI";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import WorkoutExercisesHistoryUI from "../Workout/WorkoutExercisesHistoryUI";
import { s3baseUrl } from "src/config/config";
import ScheduleWorkouts from "./ScheduleWorkouts";
import QuestionAddOrUpdate from "../MindSetLibrary/QuestionAddOrUpdate";
import QuestionWithAnswers from "../MindSetLibrary/QuestionWithAnswers";
import CustomPopoverNew from "src/components/CustomPopoverNew";
import { get_root_value } from "src/utils/domUtils";
import PaceCalculator from "./component/PaceCalculator";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
  customInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "0px",
      "& fieldset": {
        border: "none",
      },
    },
  },
}));

const findPaceObjectByVdot = (vdotValue) => {
  return paceFromVdot.find((paceObject) => paceObject.vdot == vdotValue);
};

const AddWorkoutCalenderClient = forwardRef((props, ref) => {
  const vdot33Object = findPaceObjectByVdot(
    props?.member_vdot ? props?.member_vdot : null,
  );
  const {
    userExerciseHistory,
    setUserExerciseHistory,
    userExerciseHistoryLoading,
  } = useContentSetting();
  const [practiceType, setPracticeType] = useState(props.practice_type);

  const checkedPace = !!props?.member_vdot;
  const [memberVdotData, setMemberVdotDataData] = useState({
    distance: props?.member_vdot_info?.race_type || "5km",
    time_interval: parseInt(props?.member_vdot_info?.time_taken) || 0,
    easy_long: "e_km",
    thre_shold: "t_km",
    interval: "i_400_m",
    pace: vdot33Object?.e_km_low || 0,
    paceUp: vdot33Object?.e_km_up || 0,
    pace1: vdot33Object?.t_km || 0,
    pace2: vdot33Object?.i_400_m || 0,
  });
  const [comment, setCommnet] = useState("");
  const [adminComment, setAdminCommnet] = useState("");
  const [file, setImage] = React.useState();
  const [imageStatus, setImageStatus] = useState(false);
  const [oldImage, setOldImage] = useState();
  const [mealArray, setMealArray] = useState([]);
  const [targrtDay, setTargrtDay] = useState("regular");
  const [isPastedWorkouts, setIsPastedWorkouts] = useState(false);
  const [selectedDay, setSelectedDay] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]);
  let check_type =
    props.practice_type === "food" || props.practice_type === "mindset";
  const [addArray, setaddArray] = useState([
    {
      ...exercise_obj(
        props?.member_vdot,
        vdot33Object,
        check_type ? "something_else" : "",
      ),
    },
  ]);
  const [addArrayExtra, setaddArrayExtra] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [workoutTitle, setWorkoutTitle] = useState("");
  const classes = useStyles();
  const [isFocused, setIsFocused] = useState(false);
  const [isFocused1, setIsFocused1] = useState(false);
  const [isPaceOpen, setIsPaceOpen] = useState(true);
  const [isHistoryOpen, setIsHistoryOpen] = useState(true);
  const [workoutDescription, setWorkoutDescription] = useState("");
  const [inputs, setInputs] = useState({
    video_url: "",
    image: "",
    meals: [],
    comment: "",
  });

  let difficultyLevels = [];

  if (
    props?.inputs?.difficulty_levels &&
    props?.inputs?.difficulty_levels.length > 0
  ) {
    difficultyLevels = props?.inputs?.difficulty_levels?.filter(
      (level) => level,
    );
  } else if (
    props?.editData?.difficulty_levels &&
    props?.editData?.difficulty_levels.length > 0
  ) {
    difficultyLevels = props?.editData?.difficulty_levels?.filter(
      (level) => level,
    );
  }

  const handleAdd = () => {
    let list = addArray;
    list.splice(addArray.length, 0, {
      ...exercise_obj(props?.member_vdot, vdot33Object),
    });
    setaddArray([...list]);
    props?.setIsLoading(false);
  };

  useImperativeHandle(ref, () => ({
    childButtonClick() {
      handleSubmit();
    },
    childButtonClick2() {
      handleSubmit().then((formDataObject) => {
        if (formDataObject) props.setWorkoutAsTem(formDataObject);
      });
    },
    childButtonClickUpdate() {
      handleSubmitUpdate();
    },
  }));

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleFocus1 = () => {
    setIsFocused1(true);
  };

  const handleBlur1 = () => {
    setIsFocused1(false);
  };

  function handleOnDragEnd(result) {
    const items = Array.from(addArray);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setaddArray(items);
  }
  const fileChangedHandler = (e) => {
    setImageStatus(true);
    setImage(URL.createObjectURL(e.target.files[0]));
    setInputs({
      ...inputs,
      ["image"]: e.target.files[0],
    });
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setIsLoading(true);
    props.setIsLoading(true);

    if (practiceType === "comment" && !inputs.comment.trim()) {
      enqueueSnackbar("Please enter a comment", { variant: "error" });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    if (practiceType == "video") {
      if (inputs.video_url) {
        if (
          urlPatternValidation(inputs.video_url) === false &&
          inputs.video_url != ""
        ) {
          enqueueSnackbar("Enter Valid Video URL", { variant: "error" });
          setIsLoading(false);
          props.setIsLoading(false);
          return;
        }
      } else {
        enqueueSnackbar("Please Enter Video URL", {
          variant: "error",
        });
        isError = true;
        setIsLoading(false);
        props.setIsLoading(false);
        return;
      }
    }

    if (inputs.video_url) {
      if (
        urlPatternValidation(inputs.video_url) === false &&
        inputs.video_url != ""
      ) {
        enqueueSnackbar("Enter Valid Video URL", { variant: "error" });
        setIsLoading(false);
        props.setIsLoading(false);
        return;
      }
    }

    if (inputs.video_url == "" && (inputs.image || oldImage)) {
      enqueueSnackbar("Please Enter Video URL", {
        variant: "error",
      });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    if (inputs.video_url && !inputs.image && !oldImage) {
      enqueueSnackbar("Please Upload Thumbnail", { variant: "error" });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    const { exerciesArray, isError } =
      practiceType === "video" ||
      practiceType === "workbook" ||
      practiceType === "comment"
        ? { exerciesArray: [], isError: false }
        : generateExerciseArray(addArray, enqueueSnackbar);

    if (isError) {
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    const programId = props.programme?._id?._id || props.programme?._id;

    const formDataObject = {
      title: workoutTitle,
      description: workoutDescription,
      library_type:
        practiceType === "workbook" ? props?.inputs?.library_type : "",
      questions: props?.questionsToSend || [],
      exercises: exerciesArray,
      admin_comment: adminComment,
      program_id: programId,
      member_id: props?.member_id,
      difficulty_levels: difficultyLevels,
      workout_date: moment(props.date).format("YYYY-MM-DD"),
      practice_type: practiceType ? practiceType : "workout",
      video_url: inputs.video_url,
      meals: inputs.meals,
      video_thumbnail: inputs.image,
      comment: inputs.comment,
    };

    const updatedDates = selectedDate.includes(formDataObject.workout_date)
      ? selectedDate
      : [...selectedDate, formDataObject.workout_date];

    const formData = new FormData();

    formData.append("title", formDataObject.title);
    formData.append("description", formDataObject.description);
    formData.append("admin_comment", formDataObject.admin_comment);
    formData.append("program_id", formDataObject.program_id);
    formData.append("member_id", formDataObject.member_id);
    formData.append("practice_type", formDataObject.practice_type);
    formData.append("library_type", formDataObject.library_type);
    formData.append("questions", JSON.stringify(formDataObject.questions));
    formData.append(
      "video_url",
      formDataObject.video_url ? formDataObject.video_url : "",
    );
    formData.append("target_day", targrtDay || "regular");
    formData.append("meals", JSON.stringify(formDataObject.meals || []));

    formData.append(
      "difficulty_levels",
      JSON.stringify(formDataObject.difficulty_levels),
    );
    formData.append("exercises", JSON.stringify(formDataObject.exercises));
    formData.append("workout_days", JSON.stringify(selectedDay));
    formData.append("workout_dates", JSON.stringify(updatedDates));
    formData.append("comment", inputs?.comment || "");
    if (imageStatus) {
      formData.append("video_thumbnail", formDataObject.video_thumbnail);
    }
    if (props?.practice_type == "video") {
      formData.append("video_only_type", JSON.stringify(props.multipleTypes));
    }

    const result = await add_edit_program_workout_member_api(formData);
    if (result.code === 200) {
      setSelectedDate([]);
      setSelectedDay([]);
      props.setMultipleType([]);
      props?.setEditWorkputData(result?.workout);
      const workout = result?.workout;
      props?.reloadList(workout?._id, result.message);
      setIsLoading(false);
      props.setIsLoading(false);
      props.setOpen(false);
      return formDataObject;
    } else {
      setIsLoading(false);
      props.setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleSubmitUpdate = async (e) => {
    if (e) e.preventDefault();
    setIsLoading(true);
    props.setIsLoading(true);

    if (practiceType === "comment" && !inputs.comment.trim()) {
      enqueueSnackbar("Please enter a comment", { variant: "error" });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    if (
      urlPatternValidation(inputs.video_url) === false &&
      inputs.video_url != ""
    ) {
      enqueueSnackbar("Enter Valid Video URL", { variant: "error" });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    if (inputs.video_url == "" && (inputs.image || oldImage)) {
      enqueueSnackbar("Please Enter Video URL", {
        variant: "error",
      });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    if (inputs.video_url && !inputs.image && !oldImage) {
      enqueueSnackbar("Please Upload Thumbnail", { variant: "error" });
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    let fullArray = [...addArray, ...addArrayExtra];
    const { exerciesArray, isError } =
      practiceType === "video" ||
      practiceType === "workbook" ||
      practiceType === "comment"
        ? { exerciesArray: [], isError: false }
        : generateExerciseArray(fullArray, enqueueSnackbar, true);

    if (isError) {
      setIsLoading(false);
      props.setIsLoading(false);
      return;
    }

    const formDataObject = {
      title: workoutTitle,
      description: workoutDescription,
      library_type:
        props?.editData?.practice_type === "workbook"
          ? props?.editData?.library_type
          : "",
      questions: props.questionsToSend || [],
      admin_comment: adminComment,
      exercises: exerciesArray,
      program_id: props.editData?.program_info?.program_id,
      practice_type: props.editData.practice_type
        ? props.editData.practice_type
        : "workout",
      member_id: props?.member_id,
      difficulty_levels: difficultyLevels,
      _id: props?.editData?._id,
      workout_date: moment(props.date).format("YYYY-MM-DD"),
      video_url: inputs.video_url,
      meals: inputs.meals,
      video_thumbnail: inputs.image,
      comment: inputs?.comment,
    };

    const updatedDates = selectedDate.includes(formDataObject.workout_date)
      ? selectedDate
      : [...selectedDate, formDataObject.workout_date];

    const formData = new FormData();

    formData.append("title", formDataObject.title);
    formData.append("description", formDataObject.description);
    formData.append("admin_comment", formDataObject.admin_comment);
    formData.append("program_id", formDataObject.program_id);
    formData.append("member_id", formDataObject.member_id);
    formData.append("_id", formDataObject._id);
    formData.append("practice_type", formDataObject.practice_type);
    formData.append("comment", inputs?.comment || "");
    formData.append("library_type", formDataObject.library_type);
    formData.append("questions", JSON.stringify(formDataObject.questions));
    formData.append("target_day", targrtDay || "regular");
    formData.append("meals", JSON.stringify(formDataObject.meals || []));
    formData.append(
      "video_url",
      formDataObject.video_url ? formDataObject.video_url : "",
    );
    formData.append(
      "difficulty_levels",
      JSON.stringify(formDataObject.difficulty_levels),
    );
    formData.append("exercises", JSON.stringify(formDataObject.exercises));
    formData.append("workout_days", JSON.stringify(selectedDay));
    formData.append("workout_dates", JSON.stringify(updatedDates));
    if (imageStatus) {
      formData.append("video_thumbnail", formDataObject.video_thumbnail);
    }

    if (props?.editData?.practice_type == "video") {
      formData.append(
        "video_only_type",
        JSON.stringify(props?.editData?.video_only_type),
      );
    }

    const result = await add_edit_program_workout_member_api(formData);
    if (result.code === 200) {
      setSelectedDate([]);
      setSelectedDay([]);
      const workout = result?.workout;
      props?.reloadList(workout?._id, result.message);
      setIsLoading(false);
      props.setIsLoading(false);
      props.setOpen(false);
      return formDataObject;
    } else {
      setIsLoading(false);
      props.setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  useEffect(() => {
    setInputs({
      ...inputs,
      ["video_url"]: props?.editData?.video_url,
      ["meals"]: getValidMealArray(props?.editData?.meals),
      ["comment"]: props?.editData?.comment,
    });
    setTargrtDay(props?.editData?.target_day || "regular");
    setMealArray(getValidMealArray(props?.editData?.meals));
    setOldImage(props?.editData?.video_thumbnail?.thumbnail_1);

    if (props?.editData) {
      setPracticeType(props?.editData?.practice_type || "workout");
      setWorkoutTitle(props?.editData?.workout_title || props?.editData?.title);
      setWorkoutDescription(props?.editData?.description);
      setCommnet(props?.editData?.comment);
      setAdminCommnet(props?.editData?.admin_comment || "");

      const givenExercise = formatExercises(
        props?.editData?.exercises,
        false,
        props?.member_vdot,
        vdot33Object,
      );

      const givenExerciseExtra = formatExercises(
        props?.editData?.exercises,
        true,
        props?.member_vdot,
        vdot33Object,
      );

      setaddArray(givenExercise);
      setaddArrayExtra(givenExerciseExtra);
    }
  }, [props?.editData]);

  useEffect(() => {
    if (
      props?.editData?.practice_type == "video" ||
      props?.editData?.practice_type == "workbook" ||
      props?.editData?.practice_type == "comment"
    ) {
      props?.setIsLoading(false);
    } else if (!addArray.length > 0) {
      props.setIsLoading(true);
    }
  }, [addArray]);

  useEffect(() => {
    if (!vdot33Object) return;
    setMemberVdotDataData((prevState) => ({
      ...prevState,
      pace: vdot33Object[prevState.easy_long + "_low"] ?? null,
      paceUp: vdot33Object[prevState.easy_long + "_up"] ?? null,
      pace1: vdot33Object[prevState.thre_shold] ?? null,
      pace2: vdot33Object[prevState.interval] ?? null,
    }));
  }, [
    memberVdotData.easy_long,
    memberVdotData.thre_shold,
    memberVdotData.interval,
  ]);

  if (isLoading === true && !props?.editData?.practice_type == "food") {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  const hasLogs = props?.editData?.workout_has_logs;
  const isWorkout = practiceType === "workout";
  const isVideo = practiceType === "video";
  const isWorkbook = practiceType === "workbook";
  const isComment = practiceType === "comment";
  const isAddAction = props?.action_type === "ADD";
  const showHistory = isAddAction && is_LG_screen();

  const renderLoggedView = () => {
    if (isComment) {
      return (
        <Tooltip
          placement="top"
          title="Because member have responded, that is why you can't edit it."
        >
          <div className="row my-3">
            <div className="col-12">
              <TextField
                id="comment-text-logged"
                label="Write your comment here"
                placeholder="Write your comment here"
                variant="outlined"
                fullWidth
                multiline
                rows={6}
                required
                name="comment"
                value={inputs.comment}
                InputProps={{ readOnly: true }}
                disabled
              />
            </div>
          </div>
        </Tooltip>
      );
    }
    if (isWorkout) {
      return (
        <WorkoutExercisesUILogedClient
          addArray={addArray}
          setaddArray={setaddArray}
          setModalChangeExe={props.setModalChangeExe}
          memberId={props?.member_id}
          isPersonal={true}
          message="Because member have responded, that is why you can't edit it."
        />
      );
    }
    if (isVideo) return null;
    if (isWorkbook) {
      return (
        <QuestionWithAnswers
          questionsToSend={props.questionsToSend}
          setQuestionsToSend={props.setQuestionsToSend}
          editShow={props.editShow}
          setEditShow={props.setEditShow}
          is_show_only={true}
        />
      );
    }
    return (
      <AnswerdFoodMattersAndMindsetUI
        addArray={addArray}
        setaddArray={setaddArray}
        setModalChangeExe={props.setModalChangeExe}
        meals_data={props}
        mainindex={0}
        message="Because member have responded, that is why you can't edit it."
      />
    );
  };

  const renderEditableView = () => {
    if (addArray.length > 0) {
      if (isComment) {
        return (
          <div className="row my-3">
            <div className="col-12">
              <TextField
                id="comment-text"
                label="Write your comment here"
                placeholder="Write your comment here"
                variant="outlined"
                fullWidth
                multiline
                rows={6}
                required
                name="comment"
                value={inputs.comment}
                onChange={(e) => {
                  setInputs({ ...inputs, comment: e.target.value });
                  props.setModalChangeExe(true);
                }}
                InputProps={{
                  readOnly: hasLogs ? true : false,
                }}
              />
            </div>
          </div>
        );
      }
      if (isWorkout) {
        return (
          <>
            <div className="row">
              <div className={isAddAction ? "col-12 col-lg-8 p-0" : "col-12"}>
                <WorkoutExercisesUI
                  addArray={addArray}
                  setaddArray={setaddArray}
                  setModalChangeExe={props.setModalChangeExe}
                  isHistory={true}
                  memberId={props?.member_id}
                  member_vdot={props?.member_vdot}
                  member_vdot_info={props?.member_vdot_info}
                  isWithHistoryAndBigScreen={showHistory}
                />
              </div>
              {showHistory && (
                <div className="col-12 col-lg-4 pe-0">
                  <span className="fixed-position">
                    {checkedPace && (
                      <div className="mb-3">
                        <div
                          className="d-flex align-items-center justify-content-between mb-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsPaceOpen((prev) => !prev)}
                        >
                          <h5 className="title-color m-0">Pace Calculator</h5>
                          {isPaceOpen ? (
                            <ExpandLessIcon fontSize="small" />
                          ) : (
                            <ExpandMoreIcon fontSize="small" />
                          )}
                        </div>
                        {isPaceOpen && (
                          <PaceCalculator
                            checkedPace={checkedPace}
                            memberVdotData={memberVdotData}
                            setMemberVdotDataData={setMemberVdotDataData}
                            member_vdot={props?.member_vdot}
                            member_vdot_info={props?.member_vdot_info}
                          />
                        )}
                      </div>
                    )}
                    <div
                      className="d-flex align-items-center justify-content-between"
                      style={{ cursor: "pointer" }}
                      onClick={() => setIsHistoryOpen((prev) => !prev)}
                    >
                      <h5 className="title-color m-0">
                        History
                        {!userExerciseHistoryLoading &&
                          userExerciseHistory.length > 0 && (
                            <span
                              style={{
                                fontSize: "16px",
                                fontWeight: "normal",
                                marginLeft: "6px",
                                color: "#04abbb",
                              }}
                            >
                              ({userExerciseHistory.length})
                            </span>
                          )}
                      </h5>
                      {isHistoryOpen ? (
                        <ExpandLessIcon fontSize="small" />
                      ) : (
                        <ExpandMoreIcon fontSize="small" />
                      )}
                    </div>
                    {isHistoryOpen &&
                      (userExerciseHistoryLoading ? (
                        <CircularProgress
                          className={classes.loading}
                          color="primary"
                        />
                      ) : (
                        <div className="fixed-side-history">
                          {userExerciseHistory.length > 0 ? (
                            <WorkoutExercisesHistoryUI
                              addArray={userExerciseHistory}
                              setaddArray={setUserExerciseHistory}
                              notForModel={true}
                            />
                          ) : (
                            <div
                              className="text-center py-3"
                              style={{ opacity: 0.5, fontSize: "13px" }}
                            >
                              No History Found
                            </div>
                          )}
                        </div>
                      ))}
                  </span>
                </div>
              )}
            </div>
          </>
        );
      }
      if (isVideo) return null;
      if (isWorkbook) {
        return (
          <QuestionAddOrUpdate
            questionsToSend={props.questionsToSend}
            setQuestionsToSend={props.setQuestionsToSend}
            editShow={props.editShow}
            setEditShow={props.setEditShow}
            editData={props.editData}
          />
        );
      }

      return (
        <FoodMattersAndMindsetUI
          addArray={addArray}
          setaddArray={setaddArray}
          setModalChangeExe={props.setModalChangeExe}
          mainindex={0}
          inputs_meals={inputs}
          mealArray={mealArray}
          setMealArray={setMealArray}
          targrtDay={targrtDay}
          setTargrtDay={setTargrtDay}
          practiceType={practiceType}
          state={props?.editData}
          isLoading={isLoading}
        />
      );
    } else {
      if (isVideo) return null;
      if (isComment) {
        return (
          <div className="row my-3">
            <div className="col-12">
              <TextField
                id="comment-text"
                label="Write your comment here"
                placeholder="Write your comment here"
                variant="outlined"
                fullWidth
                multiline
                rows={6}
                required
                name="comment"
                value={inputs.comment}
                onChange={(e) => {
                  setInputs({ ...inputs, comment: e.target.value });
                  props.setModalChangeExe(true);
                }}
                InputProps={{
                  readOnly: hasLogs ? true : false,
                }}
              />
            </div>
          </div>
        );
      }
      if (isWorkbook) {
        return (
          <QuestionAddOrUpdate
            questionsToSend={props.questionsToSend}
            setQuestionsToSend={props.setQuestionsToSend}
            editShow={props.editShow}
            setEditShow={props.setEditShow}
            editData={props.editData}
          />
        );
      }

      return (
        <div className="text-end container my-4">
          <button className="small-contained-button" onClick={handleAdd}>
            Add Exercise
          </button>
        </div>
      );
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col-12 col-md-8">
          <FormControl
            className={!isFocused ? classes.customInput : ""}
            sx={{
              width: { sm: "100%", md: "70%" },
            }}
          >
            <TextField
              id="outlined-basic"
              variant={"outlined"}
              onFocus={handleFocus}
              className="title-Test"
              onBlur={handleBlur}
              placeholder={`${convertToTitleCase(practiceType)} Name !`}
              value={workoutTitle}
              name="workoutTitle"
              onChange={(e) => {
                if (e.target.value.length <= 30) {
                  setWorkoutTitle(e.target.value);
                  props.setModalChangeExe(true);
                }
              }}
              InputLabelProps={{
                shrink: true,
                style: { fontSize: "18px" },
              }}
              InputProps={{
                readOnly: hasLogs ? true : false,
                style: {
                  fontSize: "32px",
                  fontWeight: "500",
                },
              }}
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                fontSize: "13px",
              }}
            />
          </FormControl>
          <FormControl
            fullWidth
            className={!isFocused1 ? classes.customInput : ""}
          >
            <TextField
              id="outlined-basic"
              className="desc-Test"
              variant={"outlined"}
              onFocus={handleFocus1}
              onBlur={handleBlur1}
              placeholder={`${convertToTitleCase(practiceType)} description !`}
              value={workoutDescription}
              multiline
              rows={3}
              name="workoutTitle"
              onChange={(e) => {
                if (e.target.value.length <= 250)
                  setWorkoutDescription(e.target.value);
                props.setModalChangeExe(true);
              }}
              InputLabelProps={{
                shrink: true,
                style: { fontSize: "18px" },
              }}
              InputProps={{
                readOnly: hasLogs ? true : false,
                style: {
                  fontSize: "14px",
                  fontWeight: "500",
                  padding: 0,
                },
                maxLength: 10,
              }}
              sx={{
                borderRadius: "5px",

                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                mb: 1,
                // width: "10%",
              }}
            />
          </FormControl>
        </div>
        <div className="col-12 col-md-4 text-end mt-3 mt-md-0">
          {!props.editData && (
            <button
              className="small-contained-button ms-2"
              onClick={() => {
                setIsPastedWorkouts(true);
              }}
            >
              Schedule Workout
            </button>
          )}
        </div>
      </div>
      {practiceType !== "comment" && (
        <>
          {hasLogs ? (
            <div className="row my-3">
              <div className="col-lg-5 col-md-5 col-sm-12 ">
                <Tooltip
                  placement="top"
                  touch="on"
                  title={
                    "Because member have responded, that is why you can't edit it."
                  }
                >
                  <TextField
                    id="outlined-basic"
                    label="Video Url"
                    variant="outlined"
                    fullWidth
                    name="video_url"
                    disabled={hasLogs ? true : false}
                    value={inputs.video_url}
                    onChange={handleChange}
                  />
                </Tooltip>
              </div>
              <div className="col-lg-7 col-md-7 col-sm-12">
                <div className="row w-100 div-style ms-0 pt-0">
                  <div className="col-lg-5 col-md-5 col-sm-12">
                    <p className="mb-0">
                      Upload thumbnail {practiceType === "video" ? "*" : ""}
                    </p>
                    <FormHelperText className="pt-0" sx={{ fontSize: 9 }}>
                      Image Size(500 X 500) ("JPG", "JPEG", "PNG","WEBP")
                    </FormHelperText>
                  </div>
                  <div className=" col-lg-2 col-md-2 col-sm-12">
                    {file ? (
                      <img className="image-border" src={file} height="50" />
                    ) : oldImage ? (
                      <img
                        className="image-border"
                        src={s3baseUrl + oldImage}
                        height="50"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-lg-5 col-md-5 col-sm-12  text-lg-end text-md-end text-sm-start pt-2">
                    <Tooltip
                      placement="top"
                      touch="on"
                      title={
                        "Because member have responded, that is why you can't edit it."
                      }
                    >
                      <label htmlFor="contained-button-file">
                        <Button
                          className="small-contained-button"
                          startIcon={<FileUploadIcon />}
                          component="span"
                          variant="contained"
                          size="small"
                          disabled={hasLogs ? true : false}
                        >
                          Upload
                        </Button>
                      </label>
                    </Tooltip>
                  </div>
                </div>
                {inputs?.image?.name == "" ? (
                  ""
                ) : (
                  <p className="text-secondary">{inputs?.image?.name}</p>
                )}
              </div>
            </div>
          ) : (
            <div className="row my-3">
              <div className="col-11 video-text">
                <p>
                  The video URL and the thumbnail image are linked, as adding a
                  video URL requires a thumbnail and vice versa. The thumbnail
                  will appear on the calendar, and clicking it will open the
                  popup.
                </p>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-12 ">
                <TextField
                  id="outlined-basic"
                  label="Video Url"
                  required={practiceType == "video"}
                  variant="outlined"
                  fullWidth
                  name="video_url"
                  disabled={hasLogs ? true : false}
                  value={inputs.video_url}
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-7 col-md-7 col-sm-12">
                <div className="row w-100 div-style ms-0 pt-0">
                  <div className="col-lg-5 col-md-5 col-sm-12">
                    <p className="mb-0">
                      Upload Video Thumbnail{" "}
                      {practiceType === "video" ? "*" : ""}
                    </p>
                    <FormHelperText className="pt-0" sx={{ fontSize: 9 }}>
                      Image Size(500 X 500) ("JPG", "JPEG", "PNG","WEBP")
                    </FormHelperText>
                  </div>
                  <div className=" col-lg-2 col-md-2 col-sm-12">
                    {file ? (
                      <img className="image-border" src={file} height="50" />
                    ) : oldImage ? (
                      <img
                        className="image-border"
                        src={s3baseUrl + oldImage}
                        height="50"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-lg-5 col-md-5 col-sm-12  text-lg-end text-md-end text-sm-start pt-2">
                    <label htmlFor="contained-button-file">
                      <input
                        accept=".jpg, .jpeg, .png, .webp"
                        id="contained-button-file"
                        multiple
                        type="file"
                        name="image"
                        required
                        onChange={(e) => fileChangedHandler(e)}
                        style={{ display: "none" }}
                      />

                      <Button
                        className="small-contained-button"
                        startIcon={<FileUploadIcon />}
                        component="span"
                        variant="contained"
                        size="small"
                        disabled={hasLogs ? true : false}
                      >
                        Upload
                      </Button>
                    </label>
                  </div>
                </div>
                {inputs?.image?.name == "" ? (
                  ""
                ) : (
                  <p className="text-secondary">{inputs?.image?.name}</p>
                )}
              </div>
            </div>
          )}
        </>
      )}
      <DragDropContext
        onDragEnd={handleOnDragEnd}
        className="h-100"
        isDragDisabled={true}
      >
        <Droppable droppableId="characters" isDragDisabled={true}>
          {(provided) => (
            <div
              className="characters"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {hasLogs ? renderLoggedView() : renderEditableView()}
              {addArrayExtra.length > 0 && (
                <>
                  <div className="container my-4">
                    <h2>
                      <Icon icon="mdi:bicycle-electric" /> Extra work
                    </h2>
                    These exercises aren’t part of the original workout
                  </div>
                  <WorkoutExercisesUIClient
                    addArray={addArrayExtra}
                    setaddArray={setaddArrayExtra}
                    setModalChangeExe={props.setModalChangeExe}
                    message={
                      "Member's Extra Work! , that is why you can't edit it."
                    }
                  />
                </>
              )}
              {practiceType !== "comment" && (
                <>
                  {comment && (
                    <div
                      className=" my-3"
                      style={{
                        whiteSpace: "break-spaces",
                        fontSize: 14,
                        opacity: 0.7,
                        color: "black",
                      }}
                    >
                      <span
                        style={{
                          opacity: 1,
                          fontWeight: "bold",
                          display: "block",
                          color: get_root_value("--portal-theme-primary"),
                        }}
                      >
                        Comment
                      </span>
                      <div className="ms-0">{comment}</div>
                    </div>
                  )}
                  {comment && (
                    <div className=" my-2">
                      <TextField
                        id="outlined-basic"
                        size="small"
                        variant="outlined"
                        placeholder="Add Reply here!"
                        label="Reply"
                        type="text"
                        value={adminComment}
                        name="description"
                        multiline
                        rows={5}
                        onChange={(e) => setAdminCommnet(e.target.value)}
                        InputLabelProps={{
                          shrink: true,
                          style: { fontSize: "14px" },
                        }}
                        InputProps={{
                          style: { fontSize: "14px" },
                        }}
                        sx={{
                          borderRadius: "5px",
                          mt: 2,
                          width: "100%",
                        }}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <CustomPopoverNew
        isOpenPop={isPastedWorkouts}
        isClosePop={setIsPastedWorkouts}
        title="Schedule Workout"
        componentToPassDown={
          <div className="px-4 pb-3">
            <ScheduleWorkouts
              props={props?.date}
              programme={props?.programme}
              selectedDay={selectedDay}
              setSelectedDay={setSelectedDay}
              setSelectedDate={setSelectedDate}
              selectedDate={selectedDate}
              setIsPastedWorkouts={setIsPastedWorkouts}
            />
          </div>
        }
      />
    </div>
  );
});
export default AddWorkoutCalenderClient;
